import { render, staticRenderFns } from "./BatteryTag.vue?vue&type=template&id=04849981&scoped=true&lang=pug&"
var script = {}
import style0 from "./BatteryTag.vue?vue&type=style&index=0&id=04849981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04849981",
  null
  
)

export default component.exports